import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/caitech-app-icon.png'


const _withScopeId = n => (_pushScopeId("data-v-dea77dae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "app-store-banner"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "app-icon-img",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "text-size-16 text-weight-700" }
const _hoisted_5 = { class: "text-size-10 text-mild" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex-grow-1" }, null, -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "install-button" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "install-button-label" }, "\n              インストール\n            ")
  ])
], -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!

  return (_ctx.shouldShown)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.product.name), 1),
          _createTextVNode(),
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.product.name) + " APP をインストール\n      ", 1)
        ]),
        _createTextVNode(),
        _hoisted_6,
        _createTextVNode(),
        _createElementVNode("div", null, [
          _createElementVNode("a", { href: _ctx.appStoreLink }, _hoisted_9, 8, _hoisted_7)
        ]),
        _createTextVNode(),
        _createVNode(_component_FeatherIcon, {
          icon: "x",
          size: "15",
          onClick: _ctx.onClose
        }, null, 8, ["onClick"])
      ]))
    : _createCommentVNode("", true)
}